/**
 * UBL Hook for Model Size Container
 *
 * @description 모델 정보 영역 UBL 로깅
 */
import { useUBL, useUBLContext } from '@common/log-manager';

export const useModelSizeUBL = () => {
  const sendUBL = useUBL();
  const ublContext = useUBLContext();

  const navigation = ublContext.navigation ?? 'product_detail';

  /**
   * 모델정보 영역 노출
   */
  const modelInfoImpressionUBL = () => {
    sendUBL({
      category: 'impression',
      navigation,
      navigation_sub: ublContext.navigation_sub,
      object_section: 'subtab_size_model_info',
      object_type: 'image',
      data: ublContext.data,
    });
  };

  /**
   * @deprecated 새로운 함수 사용 권장: modelInfoImpressionUBL
   */
  const impressionModelSize = (catalog_product_id: string) => {
    sendUBL({
      category: 'impression',
      navigation,
      navigation_sub: ublContext.navigation_sub,
      object_section: 'subtab_size_model_info',
      object_type: 'image',
      data: { ...ublContext.data, catalog_product_id },
    });
  };

  return {
    // impression
    modelInfoImpressionUBL,
    // 기존 함수 (호환성)
    impressionModelSize,
  };
};
